/**
 * Portefeuille — totaux par devise (D26).
 *
 * Un total n'additionne jamais deux devises : une mission de 10 000 FCFA comptait pour 10 000 € dans le portefeuille.
 * Les montants de l'expéditeur restent dans la devise de chaque mission, sans conversion (comme les cartes de
 * `/annonces`) ; ceux du transporteur viennent du serveur, en euros (`GET /payouts/wallet`).
 */
import CurrencyService from '@/services/CurrencyService';

/** Somme par devise : [{ currency, amount }], dans l'ordre de première apparition. `amountOf(m)` donne le montant. */
export function totalsByCurrency(missions, keep, amountOf) {
  const totals = new Map();
  (missions || []).filter(keep).forEach((m) => {
    const currency = (m.currency || 'EUR').toUpperCase();
    totals.set(currency, (totals.get(currency) || 0) + Number(amountOf(m) || 0));
  });
  return [...totals.entries()].map(([currency, amount]) => ({ currency, amount: Math.round(amount * 100) / 100 }));
}

/** « 120 € · 10 000 FCFA », ou « 0 € » quand il n'y a rien. */
export function totalsLabel(totals) {
  if (!totals || totals.length === 0) return CurrencyService.formatAmount(0, 'EUR');
  return totals.map((t) => CurrencyService.formatAmount(t.amount, t.currency)).join(' · ');
}

/** Un montant en euros du serveur : « 14,50 € ». */
export function euros(amount) {
  return `${Number(amount || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}

const PAYOUT_STATUS = {
  paid: 'Arrivé',
  in_transit: 'En route',
  pending: 'En préparation',
  failed: 'Échec',
  canceled: 'Annulé',
};

/** État d'un virement vers la banque, tel que Stripe le donne, en français. */
export function bankPayoutStatus(status) {
  return PAYOUT_STATUS[status] || status || '·';
}
